import { useRtfInputState } from "@/zustand/RtfInputState";

import { useNavigationState } from "@/zustand/NavigationState";
import { useEffect, useState } from "react";

import { processRtfLink } from "@/middleware/links";

export default function RtfLinkPreview() {
  const activeChatId = useNavigationState((state) => state.activeChatId);

  const linkMessage = useRtfInputState(
    (state) => state.linkMessages[activeChatId || ""],
  );
  const clearLinkMessage = useRtfInputState((state) => state.clearLinkMessage);

  const linkMessageMetadata = useRtfInputState(
    (state) => state.linkMessagesMetadata[activeChatId || ""],
  );
  const setLinkMessageMetadata = useRtfInputState(
    (state) => state.setLinkMessageMetadata,
  );
  const clearLinkMessageMetadata = useRtfInputState(
    (state) => state.clearLinkMessageMetadata,
  );

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!linkMessage || !activeChatId) {
      return;
    }

    const scrapeURL = async () => {
      if (linkMessageMetadata) {
        return;
      }
      // try {
      setIsLoading(true);

      const processRtfLinkMetadata = await processRtfLink({
        link: linkMessage,
        chatId: activeChatId,
      });

      if (processRtfLinkMetadata) {
        setLinkMessageMetadata(activeChatId, processRtfLinkMetadata);
      } else {
        clearLinkMessageMetadata(activeChatId);
      }

      setIsLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      // } catch (error) {
      //   clearLinkMessageMetadata(activeChatId);
      //   clearLinkMessage(activeChatId);
      // }
    };

    scrapeURL();
  }, [
    activeChatId,
    clearLinkMessage,
    clearLinkMessageMetadata,
    linkMessage,
    linkMessageMetadata,
    setLinkMessageMetadata,
  ]);

  if (!linkMessage) {
    return null;
  }

  // skeleton loader
  if (isLoading) {
    return (
      <div className="w-full">
        <div className="flex min-w-0 select-none items-center gap-2 rounded-md bg-muted px-3 py-2">
          <div className="h-[80px] w-[100px] shrink-0 animate-pulse rounded-md bg-foreground/10 lg:w-[150px]" />
          <div className="flex flex-1 flex-col px-3 leading-5">
            <div className="mb-1 h-4 w-full shrink-0 animate-pulse bg-foreground/10" />
            <div className="mb-1 h-4 w-full shrink-0 animate-pulse bg-foreground/10" />
          </div>
        </div>
      </div>
    );
  }

  if (!linkMessageMetadata) {
    return null;
  }

  return (
    <div className="w-full">
      <div className="flex min-w-0 select-none items-center gap-2 rounded-md bg-muted px-3 py-2">
        {linkMessageMetadata.image && (
          <img
            src={linkMessageMetadata.image}
            className="h-[80px] w-[100px] shrink-0 rounded-md object-cover lg:w-[150px]"
          />
        )}

        {!linkMessageMetadata.image && (
          <div className="flex h-[80px] w-[100px] shrink-0 items-center justify-center rounded-md bg-foreground object-cover align-middle lg:w-[150px]">
            <img src={linkMessageMetadata.faviconUrl} className="size-10" />
          </div>
        )}
        <div className="flex flex-1 flex-col overflow-hidden px-3 leading-5">
          <p className="min-w-0 truncate rounded-md text-lg text-primary">
            {linkMessageMetadata.title}
          </p>
          <p className="text-md min-w-0 truncate rounded-md">
            {linkMessageMetadata.description}
          </p>
        </div>
      </div>
    </div>
  );
}
